// src/components/AttendanceCsvPane.jsx
// 出席記録CSVの取り込み（出席記録ページの一部）【2026-09-04】
//
// 元は /csv-import の「出席記録」タブ。取り込み先の授業を選ぶ必要があったが、
// 出席記録の中に置くことで親ページの授業がそのまま対象になる。
//
// 受講者名簿（manabaの名簿）の取り込みは「受講者名簿」ページ側にある。

import React, { useState } from 'react';
import SaveConsent from './SaveConsent';

export default function AttendanceCsvPane({ classId, className, setErr, setMsg }) {
  const [file, setFile]     = useState(null);
  const [busy, setBusy]     = useState(false);
  const [result, setResult] = useState(null);
  // サーバーに保存してよいかの確認【2026-09-11】。名簿以外は既定オフ
  const [saveOk, setSaveOk] = useState(false);

  const upload = async (e) => {
    e.preventDefault();
    if (!file) return;
    if (!saveOk) { setErr('サーバーに保存することを確認してください'); return; }
    setBusy(true); setErr(''); setMsg(''); setResult(null);
    try {
      const fd = new FormData();
      fd.append('file', file);
      fd.append('classId', classId);
      const res = await fetch('/api/csv-import/attendance', {
        method: 'POST',
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        body: fd
      });
      const d = await res.json();
      if (!res.ok || !d.success) throw new Error(d.message || '取り込みに失敗しました');
      setResult(d);
      setMsg('出席記録を取り込みました');
      setFile(null);
      setSaveOk(false);   // 次のファイルでも改めて確認してもらう
    } catch (e) { setErr(e.message); }
    finally     { setBusy(false); }
  };

  return (
    <>
      <div className="card">
        <div className="card-header"><h2>出席記録CSVを取り込む</h2></div>
        <p style={{ fontSize: '0.88rem', color: '#4b5563', lineHeight: 1.8, marginTop: 0 }}>
          カードリーダーなどで記録した出席データを、<strong>{className || 'この授業'}</strong> に取り込みます。
          Shift-JIS のファイルにも対応しています。
        </p>

        <div style={{ background: '#f9fafb', borderRadius: 8, padding: '0.6rem 0.9rem', marginBottom: '1rem' }}>
          <div style={{ fontSize: '0.82rem', color: '#4b5563', marginBottom: '0.3rem' }}>CSVの形式</div>
          <code style={{ fontSize: '0.8rem' }}>
            日時,学籍番号,氏名,セッション開始時刻,モード,時刻同期,セッション番号,サービスコード
          </code>
        </div>

        <form onSubmit={upload}>
          <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
            <input type="file" accept=".csv" key={file ? 'f' : 'e'}
                   onChange={e => { setFile(e.target.files[0] || null); setSaveOk(false); }} />
          </div>

          {file && (
            <SaveConsent
              checked={saveOk}
              onChange={setSaveOk}
              title="出席記録をサーバーに保存します"
              items={['学籍番号・氏名・打刻日時・出欠の状態']}
              note="既に同じ回の記録があれば上書きされます。"
              defaultsOn={false}
            />
          )}

          <button className="btn-primary" type="submit" disabled={busy || !file || !saveOk}>
            {busy ? '取り込み中…' : '取り込む'}
          </button>
        </form>

        {result && (
          <div style={{ marginTop: '0.9rem', fontSize: '0.9rem', background: '#f9fafb', borderRadius: 8, padding: '0.75rem 1rem' }}>
            <p style={{ margin: 0 }}>
              総レコード {result.totalRecords} ・ 成功 {result.successCount}
              {result.updateCount !== undefined && ' ・ 更新 ' + result.updateCount}
              {result.skipCount   !== undefined && ' ・ スキップ ' + result.skipCount}
              {result.newUsersCount > 0 && ' ・ 新規ユーザー ' + result.newUsersCount + '人'}
            </p>
            {result.errorCount > 0 && (
              <p style={{ margin: '0.4rem 0 0', color: '#dc2626' }}>
                エラー {result.errorCount} 件
                {result.errors && result.errors.length > 0 &&
                  '： ' + result.errors.slice(0, 5).map(x => x.row + '行目(' + x.error + ')').join(' / ')}
              </p>
            )}
          </div>
        )}
      </div>

      <div className="card" style={{ background: '#f8fafc' }}>
        <p style={{ margin: 0, fontSize: '0.88rem', color: '#555', lineHeight: 1.8 }}>
          受講者の名簿（manabaのコースメンバーCSV）を取り込みたい場合は、
          左の「受講者名簿」から行ってください。
        </p>
      </div>
    </>
  );
}
